import { Button, Checkbox, Typography } from '@mui/material'
import { MoreVertical20Regular } from '@/components/Icon'
import threadRowStyles from '@/components/SecondaryLeftNavigation/components/ThreadListRow.module.scss'
import {
  getDocumentExtensionLabel,
  getDocumentIconTone,
  getDocumentTypeIcon,
} from './documentItemMeta'
import DocumentStatusPill from './DocumentStatusPill.jsx'
import styles from './documentsPage.module.scss'
import { documentsGridCardKebabSx } from './documentsGridCardKebabSx.js'
import { documentsPickerCheckboxSx } from './documentsPickerCheckboxSx.js'

/**
 * @param {{
 *   item: import('./documentsDemoData').DocumentItem,
 *   menu: ReturnType<typeof useDocumentsTableMenu>,
 *   pickerMode?: boolean,
 *   isSelected?: boolean,
 *   onToggleSelect?: (id: string) => void,
 * }} props
 */
export function DocumentsGridCard({
  item,
  menu,
  pickerMode = false,
  isSelected = false,
  onToggleSelect,
}) {
  const Icon = getDocumentTypeIcon(item.category)
  const tone = getDocumentIconTone(item.category)
  const menuOpenForRow = menu.openMenu && menu.menuDocumentId === item.id
  const extensionLabel = getDocumentExtensionLabel(item.name)

  const handleToggle = () => onToggleSelect?.(item.id)

  return (
    <article
      className={`${styles.gridCard}${pickerMode ? ` ${styles.pickerCard}` : ''}`}
      onClick={pickerMode ? handleToggle : undefined}
      onKeyDown={
        pickerMode
          ? (event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault()
                handleToggle()
              }
            }
          : undefined
      }
      role={pickerMode ? 'button' : undefined}
      tabIndex={pickerMode ? 0 : undefined}
    >
      {pickerMode ? (
        <Checkbox
          size="small"
          className={styles.gridCardCheckbox}
          checked={isSelected}
          onChange={handleToggle}
          onClick={(event) => event.stopPropagation()}
          inputProps={{ 'aria-label': `Select ${item.name}` }}
          sx={documentsPickerCheckboxSx}
        />
      ) : null}
      <div className={styles.gridCardHeader}>
        <Typography variant="body2" color="text.primary" className={styles.gridCardTitle}>
          {item.name}
        </Typography>
        <DocumentStatusPill status={item.status} />
        {pickerMode ? null : (
          <Button
            type="button"
            variant="text"
            className={`${threadRowStyles.kebab} ${styles.gridCardKebab}`}
            sx={documentsGridCardKebabSx}
            aria-label={`Options for ${item.name}`}
            aria-expanded={menuOpenForRow}
            aria-haspopup="true"
            onClick={(event) => menu.handleOpenMenu(event, item.id)}
          >
            <MoreVertical20Regular className={threadRowStyles.kebabIcon} aria-hidden />
          </Button>
        )}
      </div>
      <div className={`${styles.gridCardPreview} ${styles[`gridCardPreview_${tone}`]}`}>
        <Icon className={styles.gridCardPreviewIcon} aria-hidden />
      </div>
      <Typography variant="caption" color="text.secondary" className={styles.gridCardMeta}>
        {extensionLabel} • {item.sizeLabel}
      </Typography>
    </article>
  )
}
